import { Component, OnInit, signal } from '@angular/core';
import { AuthService, LogoutService } from '@frontend/common';
import { ActivityLogService } from '@frontend/core';

import { User } from '@frontend/common';
import { MainNavigationLink } from '@frontend/common';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-interculturalist-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Culture TTT';

  logoutObs : Observable<any> = new Observable();
  user = signal<User | null | undefined>(undefined);
  userSubscription : Subscription | null = null;
  isAuthenticated: boolean = false;
  loading = false;
  error = null;
  sidenavMode : string = 'slim';
  mainNavigationLinks: MainNavigationLink[];
  brandLogoBanner = signal<string | undefined>(undefined); // temporary solution TODO move this logic elsewhere

  constructor(
    private authService: AuthService,
    private activityLogService: ActivityLogService,
    private logoutService : LogoutService,
  ) {
    this.mainNavigationLinks = [
      {labelText: undefined, labelLanguageKey : 'common.news', routerLinkValue: ['/news'], condition: ''},
      {labelText: undefined, labelLanguageKey : 'navigation.shows', routerLinkValue: ['/shows'], condition: ''},
      // {labelText: null, labelLanguageKey : 'platform.culturequestion', routerLinkValue: ['/culturequestion'], condition: ''},
      // {labelText: null, labelLanguageKey : 'platform.ciprofile', routerLinkValue: ['/ciprofile'], condition: ''},
      // {labelText: null, labelLanguageKey : 'platform.interculturalist', routerLinkValue: ['/interculturalist'], condition: ''},
      {labelText: undefined, labelLanguageKey : 'navigation.ideas', routerLinkValue: ['/ideas'], condition: 'hideIfNoUser'},
      {labelText: undefined, labelLanguageKey : 'content.contributions', routerLinkValue: ['/contributions'], condition: 'hideIfNoUser'}, 
      // {labelText: null, labelLanguageKey : 'navigation.hubs', routerLinkValue: ['/interculturalist-hubs'], condition: ''},
      // {labelText: undefined, labelLanguageKey : 'platform.cco', routerLinkValue: ['/cultureconnector'], condition: ''},
    ];
  }

  logout() {
    this.loading = true;
    this.logoutObs = this.logoutService.logout();
    this.logoutObs.subscribe(
      (response) => {
        this.loading = false;
      },
      (error) => {
        this.error = error;
        this.loading = false;
      }
    );
  }

  
  getUser() {
    this.loading = true;
    this.error = null;

    let getUserSub = this.authService.getUser(false).subscribe(
      () => {
        this.loading = false;
      },
      (errorMessage) => {
        this.error = errorMessage;
        this.loading = false;
      }
    );
  }
  changeSidenavMode (newMode : string) {
    newMode = newMode ? newMode : this.sidenavMode === 'wide' ? 'slim' : 'wide';
    this.sidenavMode = newMode;
  };
  ngOnInit() {
    this.userSubscription = this.authService.user.subscribe(
      (user) => {
        this.user.set(user);
        this.isAuthenticated = !!user;
        this.activityLogService.logDefaultSiteVisit();
      },
      (error) => {
        this.activityLogService.logDefaultSiteVisit();
      }
    );
    if (this.authService.token) {
      this.getUser();
    }
  }

  ngOnDestroy() {
    // if(this.userSubscription){ // This component should never be destroyed
    //   this.userSubscription.unsubscribe();
    // }
  }
}
